import type { ApiReturnSite } from '@highimpact-frontend/api-types';
import type { Geometry } from '@highimpact-frontend/map-geometry';

import type { Datasource } from './mapTypes';

// -- type definitions --

export interface MapLayerInfo {
  readonly info: string;
  readonly geometry: Geometry<number, number>;
}

// -- helper functions --

/**
 * Extracts point/polygon geometries for the requested site ids.
 */
export function extractSiteGeometriesFromCatalog(
  sites: readonly ApiReturnSite[],
  siteIds: readonly number[]
): MapLayerInfo[] {
  const idSet = new Set(siteIds);

  return sites
    .filter((site) => idSet.has(site.id) && site.position)
    .map((site) => ({
      info: site.name,
      geometry: site.position as NonNullable<typeof site.position>,
    }));
}

/**
 * Builds map layer geometries from scoped site catalog rows.
 */
export function buildMapLayersFromDataSources(
  dataSource: readonly Datasource[],
  sites: readonly ApiReturnSite[]
): MapLayerInfo[] {
  return dataSource.flatMap((source) => {
    if (source.entity !== 'sites') {
      return [];
    }

    return extractSiteGeometriesFromCatalog(sites, source.ids);
  });
}
